import React from "react";
import servicesProperty from "assets/services-image/services_property.png";

const Property = () => {
  return (<div className="services-section">
    <div className="services-section--content">
      <h2>Property</h2>
      <ul>
        <li>
          <p><b>Property Listings:</b> Manage property details, photos and descriptions.</p>
        </li>
        <li>
          <p><b>Availability Management:</b> Track availability status of properties.</p>
        </li>
        <li>
          <p><b>Site Visits:</b> Schedule and log property site visits.</p>
        </li>
        <li>
          <p><b>Property Comparisons:</b> Compare multiple properties for clients.</p>
        </li>
        <li>
          <p><b>Valuation Tools:</b> Estimate property values based on various parameters.</p>
        </li>
      </ul>
    </div>
    <div className="services-section--image">
      <img src={servicesProperty} alt="Property"/>
    </div>
  </div>);
};

export default Property;
